<template>
  <section class="grounp-section">
    <div class="group-organization">
      <div class="group-title">
          <i class="iconfont icon--groups el-button--text"></i>&nbsp;{{item.name_cn}}
          <div class="editing" v-if="editing">
            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link el-button--text">
                <i class="iconfont icon--menu-dot"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="hideModule">隐藏模块</el-dropdown-item>
                <el-dropdown-item command="sortModule">模块排序</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
      </div>
      <swiper :options="swiperOption" v-if="!isMobile">
        <swiper-slide v-for="(itemarr, indexarr) in groupData" :key="indexarr" v-if="item.data.length > 1">
          <el-row :gutter="20" style="height: 150px;">
            <el-col :span="12" v-for="(item, index) in itemarr" :key="index">
              <div class="group-swi el-button--text">
                <a :href="groupUrl + '/' + item.id" target="_blank">
                  <div class="group-content">
                    <p class="group-name el-button--primary el-button--text">{{item.title}}</p>
                    <p class="group-number el-button--text">{{item.total_members}}&nbsp;成员</p>
                  </div>
                  <p class="unit-name">{{item.university}}</p>
                </a>
              </div>
            </el-col>
          </el-row>
        </swiper-slide>
        <div class="swiper-pagination" v-if="groupData.length > 1"  slot="pagination"></div>
      </swiper>

        <!-- 长度为1 web-->
      <el-row v-if="item.data.length === 1 && !isMobile">
        <el-col :span="24" v-for="(item, index) in item.data" :key="index">
          <div class="group-swi el-button--text">
            <a :href="groupUrl + '/' + item.id" target="_blank">
              <div class="group-content">
                <p class="group-name el-button--primary el-button--text">{{item.title}}</p>
                <p class="group-number el-button--text">{{item.total_members}}&nbsp;成员</p>
              </div>
              <p class="unit-name">{{item.university}}</p>
            </a>
          </div>
        </el-col>
      </el-row>
      <swiper :options="swiperOption" v-if="isMobile">
        <swiper-slide v-for="(item ,index) in item.data" :key="index">
          <el-row :gutter="20" style="height: 150px;">
            <el-col :span="24">
              <div class="group-swi el-button--text">
                <a :href="groupUrl + '/' + item.id" target="_blank">
                  <div class="group-content">
                    <p class="group-name el-button--primary el-button--text">{{item.title}}</p>
                  </div>
                  <div class="unit-name">
                    {{item.university}}
                    <p class="numbers el-button--primary el-button--text">{{item.total_members}}&nbsp;成员</p>
                  </div>
                </a>
              </div>
            </el-col>
          </el-row>
        </swiper-slide>
        <div class="swiper-pagination" v-if="item.data.length > 1" slot="pagination"></div>
      </swiper>
    </div>
  </section>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  props: {
    item: Object,
    isMobile: Boolean,
    editing: Boolean,
    index: Number
  },
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      swiperOption: {
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          bulletActiveClass: 'el-button--primary'
        }
      }
    }
  },
  computed: {
    groupUrl () {
      return `${process.env.GROUP_ORIGIN}`
    },
    groupData () {
      let splitArray = (arr, len) => {
        let arrLength = arr.length
        let newArr = []
        for (let i = 0; i < arrLength; i += len) {
          newArr.push(arr.slice(i, i + len))
        }
        return newArr
      }
      return splitArray(this.item.data, 2)
    }
  },
  methods: {
    handleCommand (command) {
      if (command === 'sortModule') {
        this.$emit('sortModules')
      } else if (command === 'hideModule') {
        this.$emit('hideModule', this.index)
      }
    }
  }
}
</script>
<style>
.grounp-section .group-organization .swiper-container .swiper-pagination .el-button--primary,
.grounp-section .group-organization .swiper-container .swiper-pagination .el-button--primary:active,
.grounp-section .group-organization .swiper-container .swiper-pagination .el-button--primary:hover{
  opacity: 1;
}
</style>
<style scoped lang="scss">
#app .content .grounp-section{
  padding-left: 0;
  .group-organization{
    .group-title{
      .editing{
        float: right;
        font-weight: normal;
        margin-right: 5px;
        font-size: 20px;
        vertical-align: sub;
      }
    }
  }
}
.group-organization{
  width: 100%;
  height: 154px;
  margin-bottom: 43px;
  a {
    border:unset;
  }
  a:active, a:hover, a:focus{
    outline: none;
  }
  .group-swi{
    margin-top: 23px;
    width: 100%;
    height: 90px;
    border-radius: 4px;
    border: 1px solid;
    .group-content {
      margin: 20px 20px 0;
      height: 22px;
      .group-name{
        float: left;
        height: 22px;
        font-weight: 500;
        line-height: 22px;
        width: 80%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .group-number {
        float: right;
        height: 22px;
        font-weight: 500;
        line-height: 22px;
        width: 20%;
        text-align: right;
      }
    }
    .unit-name {
      margin: 10px 20px;
      font-size:14px;
      color:rgba(51,51,51,1);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .group-swi:hover {
    border-color: inherit;
    opacity: 0.8;
  }
}
.group-title{
  font-weight: 600;
  color: #333333;
  line-height: 18px;
  border-bottom: 1px solid #ccc;
  padding-bottom: 18px;
  i {
    font-size: 20px;
    vertical-align: sub;
  }
  .editing{
    float: right;
  }
}

@media screen and (max-width: 500px) {
  .grounp-section{
    overflow: hidden;
    height:220px;
  }
  .group-organization{
    .group-title{
      font-weight: 600;
      color: #333333;
      line-height: 18px;
      border-bottom: 1px solid #ccc;
      padding-bottom: 18px;
      padding-top: 39px;
      margin-left: 19px;
    }
    .group-swi {
      width: auto;
      margin: 23px 20px 0;
      height: 90px;
      border-radius: 4px;
      border: 1px solid;
      .group-content {
        .group-name {
          width:100%;
        }
      }
     .unit-name {
        .numbers {
          float:right;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Index/groups.vue